// extracted by mini-css-extract-plugin
export default {"search-container":"SelectWallet_search-container__b-zMs","clasify":"SelectWallet_clasify__h3UHS","exchanges":"SelectWallet_exchanges__FYF3d"};